import React from 'react';
import { Navigate } from 'react-router-dom';

// Parent pages are for parents only. A student is signed in when a
// childSession exists (ChildLogin.js); if they type a parent URL directly
// they are sent back to their own dashboard.
export function isStudentSignedIn() {
  try { return !!sessionStorage.getItem('childSession'); } catch { return false; }
}

export default function ParentRoute({ children }) {
  if (isStudentSignedIn()) return <Navigate to="/child/today" replace />;
  return children;
}
